import { createContext, useContext, useState } from 'react'

import { useDisclosure } from '@mantine/hooks'

export interface ReadOnlyEmailModalOptions {
  emailThreadId?: string
  selectedEmailId?: string
}

const ReadOnlyEmailModalContext = createContext(null)

const ReadOnlyEmailModalContextProvider = ({ children }) => {
  const [opened, { open, close }] = useDisclosure(false)
  const [emailThreadId, setEmailThreadId] = useState<string | null>(null)
  const [selectedEmailId, setSelectedEmailId] = useState<string | null>(null)

  const handleOpen = ({
    emailThreadId,
    selectedEmailId,
  }: ReadOnlyEmailModalOptions = {}) => {
    setEmailThreadId(emailThreadId ?? null)
    setSelectedEmailId(selectedEmailId ?? null)
    open()
  }

  const handleClose = () => {
    setEmailThreadId(null)
    setSelectedEmailId(null)
    close()
  }

  return (
    <ReadOnlyEmailModalContext.Provider
      value={{
        opened,
        handleOpen,
        handleClose,
        emailThreadId,
        selectedEmailId,
      }}
    >
      {children}
    </ReadOnlyEmailModalContext.Provider>
  )
}

export function useReadOnlyEmailModalContext() {
  return useContext(ReadOnlyEmailModalContext)
}

export { ReadOnlyEmailModalContext, ReadOnlyEmailModalContextProvider }
